var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#FDE8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.2602 28H23.7402C26.5002 28 27.6002 26.31 27.7302 24.25L28.2502 15.99C28.3902 13.83 26.6702 12 24.5002 12C23.8902 12 23.3302 11.65 23.0502 11.11L22.3302 9.66C21.8702 8.75 20.6702 8 19.6502 8H17.3602C16.3302 8 15.1302 8.75 14.6702 9.66L13.9502 11.11C13.6702 11.65 13.1102 12 12.5002 12C10.3302 12 8.61017 13.83 8.75017 15.99L9.27017 24.25C9.39017 26.31 10.5002 28 13.2602 28Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.75H17C16.59 14.75 16.25 14.41 16.25 14C16.25 13.59 16.59 13.25 17 13.25H20C20.41 13.25 20.75 13.59 20.75 14C20.75 14.41 20.41 14.75 20 14.75Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 24.13C20.3668 24.13 21.8801 22.6167 21.8801 20.75C21.8801 18.8833 20.3668 17.37 18.5001 17.37C16.6334 17.37 15.1201 18.8833 15.1201 20.75C15.1201 22.6167 16.6334 24.13 18.5001 24.13Z",
    fill: "#ED1C24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCameraIcon);
export default __webpack_public_path__ + "static/media/chat-camera-icon.39ae939cf22a1df3026b96382e38cc61.svg";
export { ForwardRef as ReactComponent };